import { render, staticRenderFns } from "./social-svg-icons.vue?vue&type=template&id=70a7b10c&scoped=true"
import script from "./social-svg-icons.vue?vue&type=script&lang=js"
export * from "./social-svg-icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7b10c",
  null
  
)

export default component.exports